import { BroadcastInterface } from '@signage-player/contracts';

/**
 * Browser fan-out via EventTarget. broadcast(event, ...args) dispatches a
 * CustomEvent whose detail is the args tuple; subscribers re-spread it.
 * No serialization — references are passed in-process.
 */
export class WebBroadcast implements BroadcastInterface {
  private readonly target = new EventTarget();

  public broadcast(event: string, ...args: any[]): void {
    this.target.dispatchEvent(new CustomEvent(event, { detail: args }));
  }

  public on<T extends any[]>(event: string, cb: (...args: T) => void): () => void {
    const handler = (ev: Event) => {
      const detail = (ev as CustomEvent).detail as any[];
      cb(...(detail as T));
    };
    this.target.addEventListener(event, handler);
    return () => this.target.removeEventListener(event, handler);
  }
}

export default WebBroadcast;
